import api from './api';

class MemberService {
  getDataMembers(dataForm) {
    return api.post('/merchant/members', dataForm);
  }

  createNewMember() {
    return api.post('/merchant/member');
  }

  getDataMemberDetail(memberId) {
    return api.post('/merchant/member/' + memberId);
  }

  addOrUpdateMember(dataForm) {
    return api.post('/merchant/member-create-or-update', dataForm);
  }

  deleteMember(memberId) {
    return api.post('/merchant/member/delete/' + memberId);
  }

  changeStatus(memberId) {
    return api.post('/merchant/member/change-status/' + memberId);
  }

  myRewards(memberId, dataForm) {
    return api.post('/merchant/member/my-reward/' + memberId, dataForm);
  }

  getVoucherAvailabel() {
    return api.post('/merchant/voucher-available');
  }

  bulkVoucher(type, dataForm) {
    return api.post('/merchant/member/bulk/voucher/' + type, dataForm);
  }

  // SF278 — Advocado voucher campaigns available to send from the member list.
  getAdvocadoVoucherCampaigns() {
    return api.post('/merchant/advocado/voucher-campaigns');
  }

  // SF278 — issue an Advocado voucher to the selected members.
  bulkAdvocadoVoucher(dataForm) {
    return api.post('/merchant/member/bulk/advocado-voucher', dataForm);
  }

  bulkChangeStatus(dataForm) {
    return api.post('/merchant/member/bulk/change-status', dataForm);
  }

  issueVoucher(dataForm) {
    return api.post('/merchant/member/issue/voucher', dataForm);
  }

  updateRemark(memberId, dataForm) {
    return api.post('/merchant/member/update-remark/' + memberId, dataForm);
  }

  updateProfileAndRemark(dataForm) {
    return api.post('/merchant/member/update-profile-remark', dataForm);
  }

  myTransaction(memberId, dataForm) {
    return api.post('/merchant/member/my-transaction/' + memberId, dataForm);
  }

  myTransactionTopup(memberId, dataForm) {
    return api.post('/merchant/member/my-transaction-topup/' + memberId, dataForm);
  }

  getFieldsMemberProfile() {
    return api.get('/merchant/get-field-member-profile');
  }

  updateFieldsMemberProfile(dataForm) {
    return api.post('/merchant/update-field-diplay-or-required', dataForm);
  }

  addNewFieldsMemberProfile(dataForm) {
    return api.post('/merchant/add-new-field-member-profile', dataForm);
  }

  deleteFieldsMemberProfile(id) {
    return api.post('/merchant/delete-field-member-profile/'+id);
  }

  getCountriesForDropdown() {
    return api.get('/countries-for-dropdown');
  }

  deleteMemberExpired() {
    return api.post('/merchant/member/delete-expired');
  }

  getCashbackExpired(memberId, dataForm) {
    return api.post('/merchant/member/get-cashback-expired/' + memberId, dataForm);
  }

  changePassCode(dataForm) {
    return api.post('/member/change-passcode', dataForm);
  }

  sendResetToInitialPasscode(dataForm) {
    return api.post('/member/send-reset-to-initial-passcode', dataForm);
  }

  voidMemberReward(memberId, dataForm) {
    return api.post('/merchant/member/' + memberId + '/void-member-reward', dataForm);
  }

  resendWaDeduction(memberId, dataForm) {
    return api.post('/merchant/member/' + memberId + '/resend-wa-deduction', dataForm);
  }
}

export default new MemberService();
